import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  reduxForm
} from 'redux-form';
import {
  BackToSignInButton,
  ErrorMessage,
  SubmitButton,
  TextField
} from '../components';

const validate = values => {
  const errors = {};

  if (!values.code) {
    errors.code = 'Required';
  } else if (values.code.length !== 6) {
    errors.code = 'Code must be 6 numbers';
  }

  return errors
};

const ConfirmSignInForm = ({
  handleSubmit,
  onResend,
  changeState,
  errorMessage = false,
  working = false
}) => {
  return (
    <form
      className="confirm-sign-in auth__form"
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <div className="auth--form-group">
        <Field
          name="code"
          component={TextField}
          label="Code"
          props={{
            disabled: working
          }}
        />
      </div>
      <SubmitButton
        busy={working}
        textOnBusy="Confirming Sign In"
        textOnIdle="Confirm Sign In"
      />
      <ErrorMessage errorMessage={errorMessage} />
      <BackToSignInButton changeState={changeState} />
    </form>
  )
};

ConfirmSignInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  changeState: PropTypes.func.isRequired,
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
  working: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'auth/confirm-sign-in',
  validate
})(ConfirmSignInForm);



// WEBPACK FOOTER //
// ./src/components/Authentication/ConfirmSignIn/ConfirmSignInForm.js